import { type Media as MediaType } from "@/payload-types";
import { SrcImage, type SrcImageProps } from "./src-image";

export interface CMSImageProps extends Omit<SrcImageProps, "src" | "alt" | "width" | "height" | "blurhash"> {
	/**
	 * Media file from Payload CMS (can be a relationship ID or full object).
	 */
	media?: (number | null) | MediaType;
	size?: keyof NonNullable<MediaType["sizes"]> | null;
}

/**
 * Renders an image from Payload CMS media collection.
 *
 * @param props - Component props.
 * @returns The rendered image element or null if no valid media is provided.
 */
export const CMSImage: React.FC<CMSImageProps> = ({ media, size = "small", ...props }) => {
	const imageMedia = media && typeof media !== "number" ? media : undefined;
	const sizedImage = size ? imageMedia?.sizes?.[size] : undefined;
	const imageSrc = sizedImage?.url || imageMedia?.url;

	if (!imageSrc) {
		return null;
	}

	return (
		<SrcImage
			{...props}
			src={imageSrc}
			alt={imageMedia?.alt || ""}
			width={sizedImage?.width || imageMedia?.width || undefined}
			height={sizedImage?.height || imageMedia?.height || undefined}
			blurhash={imageMedia && "blurhash" in imageMedia && imageMedia.mimeType !== "image/svg+xml" ? imageMedia.blurhash : undefined}
		/>
	);
};
